export const ROUTES_LIST = {
    "analytics": "/cabinet/company/:companyId/analytics",
    "bill-create-types": "/cabinet/company/:companyId/bills/create",
    "bill-create-base": "/cabinet/company/:companyId/bills/create/base",
    "bill-create-by-template": "/cabinet/company/:companyId/bills/create/by-template/:templateId",
    "bills-templates": "/cabinet/company/:companyId/bills#templates",
    "bill-view": "/cabinet/company/:companyId/bills/:billId",
    "bill-refund": "/cabinet/company/:companyId/bills/:billId/refund",
    "bills-list": "/cabinet/company/:companyId/bills",
    "bill-create-template": "/cabinet/company/:companyId/bills/templates/create",
    "bill-template-view": "/cabinet/company/:companyId/bills/templates/:templateId",
    "bill-template-edit": "/cabinet/company/:companyId/bills/templates/:templateId/edit",
    "payouts": "/cabinet/company/:companyId/payouts",
    "create-payout-to-card": "/cabinet/company/:companyId/payouts/to-card/create",
    "payout-to-card-view": "/cabinet/company/:companyId/payouts/to-card/:payoutId",
    "invoices-module": "/cabinet/company/:companyId/invoices",
}
